/**
 * @Autobind : Lie automatiquement la méthode à l'instance.
 */
export function Autobind(
  originalMethod: any,
  context: ClassMethodDecoratorContext,
) {
  context.addInitializer(function (this: any) {
    this[context.name] = originalMethod.bind(this);
  });
}
